import React from "react";
import isEqual from "is-equal";
import { toast } from "react-toastify";
import _ from "lodash";
import {
  Row,
  Col,
  Card,
  FormGroup,
  InputGroup,
  FormControl,
  Form,
  Accordion,
  Collapse,
} from "react-bootstrap";
import cx from "classnames";

import { localizedStrings } from "src/localization/index.jsx";
import LoadingMessage from "src/legacy/components/LoadingMessage";
import SendButton from "src/legacy/components/SendButton";
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import SwitchButton from "src/components/switchButton";
import Toast from "src/components/toast";

import styles from "./netsuiteConfigurationView.module.scss";
import AccessDeniedIcon from "src/legacy/images/access_denied.svg";

class NetsuiteConfigurationView extends React.Component {
  constructor(props) {
    super(props);
    const primaryIntegration = this.props.integration;

    this.state = {
      primaryId: primaryIntegration && primaryIntegration.id,
      primaryCreatedBy: primaryIntegration && primaryIntegration.createdBy,
      primaryEmail:
        (primaryIntegration && primaryIntegration.configuration.email) || "",
      primaryInstance:
        (primaryIntegration && primaryIntegration.configuration.company) || "",
      primarySyncReadAssetEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReadAssetEvent) ||
        false,
      primarySyncReadConversationEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReadConversationEvent) ||
        false,
      primarySyncReshareConversationEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReshareConversationEvent) ||
        false,
      primarySyncLeadCreatedEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncLeadCreatedEvent) ||
        false,
      primarySyncAssetDownloadEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncAssetDownloadEvent) ||
        false,
      errors: {},
      sharedFieldsSync: false,
      sharedFieldsEdit: false,
      editMode: false,
      toggleCollapse: true,
    };

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);
    this._handleSyncSharedFields = this._handleSyncSharedFields.bind(this);
    this._handleEditSharedFields = this._handleEditSharedFields.bind(this);
    this.prepareUserConfiguration = this.prepareUserConfiguration.bind(this);
    this.prepareAdminConfiguration = this.prepareAdminConfiguration.bind(this);
    this._handlePrimaryResetClicked =
      this._handlePrimaryResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedNetsuite = localizedStrings.components.integrations.netsuite;
  }

  prepareUserConfiguration(integration) {
    this.setState({
      id: integration && integration.id,
      email: (integration && integration.configuration.email) || "",
      company: (integration && integration.configuration.company) || "",
      syncReadAssetEvent:
        (integration && integration.configuration.syncReadAssetEvent) || false,
      syncReadConversationEvent:
        (integration && integration.configuration.syncReadConversationEvent) ||
        false,
      syncReshareConversationEvent:
        (integration &&
          integration.configuration.syncReshareConversationEvent) ||
        false,
      syncLeadCreatedEvent:
        (integration && integration.configuration.syncLeadCreatedEvent) ||
        false,
      syncAssetDownloadEvent:
        integration && integration.configuration.syncAssetDownloadEvent,
      errors: {},
    });
  }

  prepareAdminConfiguration(primaryIntegration) {
    this.setState({
      primaryId: primaryIntegration && primaryIntegration.id,
      primaryEmail:
        (primaryIntegration && primaryIntegration.configuration.email) || "",
      primaryInstance:
        (primaryIntegration && primaryIntegration.configuration.company) || "",
      primarySyncReadAssetEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReadAssetEvent) ||
        false,
      primarySyncReadConversationEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReadConversationEvent) ||
        false,
      primarySyncReshareConversationEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncReshareConversationEvent) ||
        false,
      primarySyncLeadCreatedEvent:
        (primaryIntegration &&
          primaryIntegration.configuration.syncLeadCreatedEvent) ||
        false,
      primaryCreatedBy: primaryIntegration && primaryIntegration.createdBy,
      primarySyncAssetDownloadEvent:
        primaryIntegration &&
        primaryIntegration.configuration.syncAssetDownloadEvent,
    });
  }

  componentDidMount() {
    const integration = _.get(this.props, "integration");
    const primaryIntegration = _.get(integration, "primaryIntegration");
    const integrationStateCode = _.get(integration, "state.code");

    if (primaryIntegration) {
      this.prepareAdminConfiguration(primaryIntegration);
      this.setState({
        toggleCollapse: true,
      });

      if (integrationStateCode === "ok") {
        this.prepareUserConfiguration(integration);
        this.setState({
          toggleCollapse: false,
        });
      }
    } else if (integration) {
      this.prepareAdminConfiguration(integration);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.integration, this.props.integration)) {
      if (nextProps.integration) {
        if (nextProps.integration.primaryIntegration) {
          this.prepareAdminConfiguration(
            nextProps.integration.primaryIntegration,
          );
          if (nextProps.integration.state.code === "ok") {
            this.prepareUserConfiguration(nextProps.integration);
          }
        } else {
          this.prepareAdminConfiguration(nextProps.integration);
        }
      }
    }
  }

  _toggleSwitchChange(field) {
    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(type) {
    let request = {
      integrationId: type === "primary" ? this.state.primaryId : this.state.id,
      syncReadAssetEvent:
        type === "primary"
          ? this.state.primarySyncReadAssetEvent
          : this.state.syncReadAssetEvent,
      syncReadConversationEvent:
        type === "primary"
          ? this.state.primarySyncReadConversationEvent
          : this.state.syncReadConversationEvent,
      syncReshareConversationEvent:
        type === "primary"
          ? this.state.primarySyncReshareConversationEvent
          : this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent:
        type === "primary"
          ? this.state.primarySyncLeadCreatedEvent
          : this.state.syncLeadCreatedEvent,
      syncAssetDownloadEvent:
        type === "primary"
          ? this.state.primarySyncAssetDownloadEvent
          : this.state.syncAssetDownloadEvent,
    };

    this.props.updateConfiguration(request).then(() => {
      toast(
        <Toast.Sucess message={this.localizedIntegrations.toast.netsuite} />,
        {
          autoClose: 3000,
        },
      );
    });
  }

  _handlePrimaryResetClicked() {
    let integration = this.props.integration;
    if (this.props.integration.primaryIntegration) {
      integration = this.props.integration.primaryIntegration;
    }

    this.setState({
      primarySyncReadAssetEvent: integration.configuration.syncReadAssetEvent,
      primarySyncReadConversationEvent:
        integration.configuration.syncReadConversationEvent,
      primarySyncReshareConversationEvent:
        integration.configuration.syncReshareConversationEvent,
      primarySyncLeadCreatedEvent:
        integration.configuration.syncLeadCreatedEvent,
      primarySyncAssetDownloadEvent:
        integration.configuration.syncAssetDownloadEvent,
    });
  }

  _handleResetClicked() {
    this.setState({
      syncReadAssetEvent:
        this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent:
        this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent:
        this.props.integration.configuration.syncReshareConversationEvent,
      syncLeadCreatedEvent:
        this.props.integration.configuration.syncLeadCreatedEvent,
      syncAssetDownloadEvent:
        this.props.integration.configuration.syncAssetDownloadEvent,
    });
  }

  _handleSyncSharedFields() {
    if (this.props.integration) {
      this.setState({
        sharedFieldsSync: true,
      });
    }
  }

  _handleEditSharedFields() {
    this.setState({ sharedFieldsEdit: true });
    this.handleEditClick();
  }

  showOverrideConfig() {
    if (!this.state?.id && this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id !== this.props.user.id;
    }
    if (
      this.props.integration &&
      this.props.integration.state.code === "auth_error"
    ) {
      return true;
    }

    return false;
  }

  userOverriding() {
    if (this.props.authenticating && this.state.primaryId) {
      return true;
    }
    return false;
  }

  handleRemoveClick() {
    this.props.deactivateNetsuiteIntegration("netsuite").then(() => {
      this.setState({
        id: null,
        toggleCollapse: true,
      });
    });
  }

  render() {
    return (
      <div className={styles.content}>
        {this.renderAuthErrorMessage()}

        {!this.props.loading && this.renderAdvancedSettings()}

        {(this.props.loading || this.userOverriding()) && this._renderLoading()}

        {!this.props.authenticating && this.showOverrideConfig() && (
          <div
            className={cx(styles.override)}
            onClick={this.props.OverrideConfig}
          >
            {this.localizedIntegrations.show_override}
          </div>
        )}

        {this.state.id && (
          <Row className={cx(styles.overrideSettings, styles.row)}>
            <Col
              md={8}
              className={cx(styles.noPadding, styles.overrideHeaderRow)}
            >
              <span className={styles.overrideHeader}>
                {this.localizedIntegrations.override_configuration}
              </span>
              <span
                className={styles.remove}
                onClick={this.handleRemoveClick.bind(this)}
              >
                {this.localizedCommons.actions.remove}
              </span>
            </Col>
            <Col md={12}>
              {!this.props.loading && this._renderUserConfiguration()}
            </Col>
          </Row>
        )}
      </div>
    );
  }

  renderAuthErrorMessage() {
    let integration = this.props.integration;

    if (integration.primaryIntegration) {
      integration = integration.primaryIntegration;
    }

    return (
      integration &&
      integration.state.code === "auth_error" && (
        <span className={styles.authMessage}>
          {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
        </span>
      )
    );
  }

  handleEditClick() {
    this.setState({
      editMode: true,
    });
  }

  renderAdvancedSettings() {
    return (
      <>
        <Row
          className={cx(styles.settings, styles.row)}
          onClick={() => {
            if (!this.state.id) {
              return;
            }
            this.setState({
              toggleCollapse: !this.state.toggleCollapse,
            });
          }}
        >
          <Col md={8} className={cx(styles.noPadding, styles.headerRow)}>
            <i
              className={cx({
                ["paperflite-plus"]:
                  !this.state.toggleCollapse && this.state.id,
                ["paperflite-minus"]:
                  this.state.toggleCollapse && this.state.id,
              })}
              aria-hidden="true"
            ></i>
            <span className={styles.settingsHeader}>
              {this.localizedIntegrations.primary_configuration}
            </span>
          </Col>
        </Row>
        <Collapse in={this.state.toggleCollapse}>
          {!this.props.loading && this._renderAdminConfiguration()}
        </Collapse>
      </>
    );
  }

  _renderUserConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8}>
          <div className={styles.form}>
            <p className={styles.errorMessage}>
              {this.state.errors && this.state.errors.apikey}
            </p>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{this.localizedNetsuite.account_id}</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.company}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              {this.localizedNetsuite.active}
            </Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{this.localizedCommons.email}</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.email}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              {this.localizedNetsuite.active_email}
            </Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{this.localizedNetsuite.sync_events}</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              {this.localizedNetsuite.config}
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{this.localizedIntegrations.configs.create_lead}</label>
                <SwitchButton
                  name="syncLeadCreatedEvent"
                  label=""
                  checked={this.state.primarySyncLeadCreatedEvent}
                  handleCheck={() => this._toggleSwitchChange("syncLeadCreatedEvent")}
                />
              </div>
              <div className={styles.event}>
                <label>{this.localizedIntegrations.configs.view_asset}</label>
                <SwitchButton
                  name="syncReadAssetEvent"
                  label=""
                  checked={this.state.syncReadAssetEvent}
                  onChange={this._toggleSwitchChange}
                  handleCheck={() => this._toggleSwitchChange("syncReadAssetEvent")}
                />
              </div>
              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.view_collection}
                </label>
                <SwitchButton
                  name="syncReadConversationEvent"
                  label=""
                  checked={this.state.syncReadConversationEvent}
                  handleCheck={() => this._toggleSwitchChange("syncReadConversationEvent")}
                />
              </div>
              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.reshare_collection}
                </label>
                <SwitchButton
                  name="syncReshareConversationEvent"
                  label=""
                  checked={this.state.syncReshareConversationEvent}
                  onChange={this._toggleSwitchChange}
                  handleCheck={() => this._toggleSwitchChange("syncReshareConversationEvent")}
                />
              </div>
              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.download_asset}
                </label>
                <SwitchButton
                  name="syncAssetDownloadEvent"
                  label=""
                  checked={this.state.syncAssetDownloadEvent}
                  handleCheck={() => this._toggleSwitchChange("syncAssetDownloadEvent")}
                />
              </div>
            </FormGroup>
            <div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                icon="fa-chevron-right"
                title={
                  this.props.updating
                    ? `${this.localizedCommons.actions.saving}...`
                    : this.localizedCommons.actions.save
                }
                primary
                disabled={this.props.updating}
                onClick={() => this._handleSaveChangesClicked("user")}
              />
              <SendButton
                title={this.localizedCommons.actions.reset}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
                onClick={this._handleResetClicked}
              />
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  _renderAdminConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} className={styles.settingsBody}>
          {!this.state.editMode && this.props.user.admin && (
            <div
              className={styles.edit}
              onClick={this.handleEditClick.bind(this)}
            >
              {this.localizedCommons.actions.edit}
            </div>
          )}
          <div className={styles.form}>
            <p className={styles.errorMessage}>
              {this.state.errors && this.state.errors.apikey}
            </p>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{this.localizedNetsuite.account_id}</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryInstance}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text>{this.localizedNetsuite.active}</Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{this.localizedCommons.email}</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryEmail}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text>{this.localizedNetsuite.active_email}</Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{this.localizedNetsuite.sync_events}</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text>{this.localizedNetsuite.config}</Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{this.localizedIntegrations.configs.create_lead}</label>

                {this.state.editMode && (
                  <SwitchButton
                    name="primarySyncLeadCreatedEvent"
                    label=""
                    checked={this.state.primarySyncLeadCreatedEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncLeadCreatedEvent")}
                  />
                )}
                {!this.state.editMode && (
                  <span
                    className={cx(styles.action, {
                      [styles.on]: this.state.primarySyncLeadCreatedEvent,
                    })}
                  >
                    {this.state.primarySyncLeadCreatedEvent
                      ? this.localizedIntegrations.actions.on
                      : this.localizedIntegrations.actions.off}
                  </span>
                )}
              </div>
              <div className={styles.event}>
                <label>{this.localizedIntegrations.configs.view_asset}</label>

                {this.state.editMode && (
                  <SwitchButton
                    name="primarySyncReadAssetEvent"
                    label=""
                    checked={this.state.primarySyncReadAssetEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncReadAssetEvent")}
                  />
                )}
                {!this.state.editMode && (
                  <span
                    className={cx(styles.action, {
                      [styles.on]: this.state.primarySyncReadAssetEvent,
                    })}
                  >
                    {this.state.primarySyncReadAssetEvent
                      ? this.localizedIntegrations.actions.on
                      : this.localizedIntegrations.actions.off}
                  </span>
                )}
              </div>
              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.view_collection}
                </label>

                {this.state.editMode && (
                  <SwitchButton
                    name="primarySyncReadConversationEvent"
                    label=""
                    checked={this.state.primarySyncReadConversationEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncReadConversationEvent")}
                  />
                )}
                {!this.state.editMode && (
                  <span
                    className={cx(styles.action, {
                      [styles.on]: this.state.primarySyncReadConversationEvent,
                    })}
                  >
                    {this.state.primarySyncReadConversationEvent
                      ? this.localizedIntegrations.actions.on
                      : this.localizedIntegrations.actions.off}
                  </span>
                )}
              </div>
              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.reshare_collection}
                </label>

                {this.state.editMode && (
                  <SwitchButton
                    name="primarySyncReshareConversationEvent"
                    label=""
                    checked={this.state.primarySyncReshareConversationEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncReshareConversationEvent")}
                  />
                )}
                {!this.state.editMode && (
                  <span
                    className={cx(styles.action, {
                      [styles.on]:
                        this.state.primarySyncReshareConversationEvent,
                    })}
                  >
                    {this.state.primarySyncReshareConversationEvent
                      ? this.localizedIntegrations.actions.on
                      : this.localizedIntegrations.actions.off}
                  </span>
                )}
              </div>

              <div className={styles.event}>
                <label>
                  {this.localizedIntegrations.configs.download_asset}
                </label>

                {this.state.editMode && (
                  <SwitchButton
                    name="primarySyncAssetDownloadEvent"
                    label=""
                    checked={this.state.primarySyncAssetDownloadEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncAssetDownloadEvent")}
                  />
                )}
                {!this.state.editMode && (
                  <span
                    className={cx(styles.action, {
                      [styles.on]: this.state.primarySyncAssetDownloadEvent,
                    })}
                  >
                    {this.state.primarySyncAssetDownloadEvent
                      ? this.localizedIntegrations.actions.on
                      : this.localizedIntegrations.actions.off}
                  </span>
                )}
              </div>
            </FormGroup>
            {this.state.editMode && (
              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="fa-chevron-right"
                  title={
                    this.props.updating
                      ? `${this.localizedCommons.actions.saving}...`
                      : this.localizedCommons.actions.save
                  }
                  primary
                  disabled={this.props.updating}
                  onClick={() => this._handleSaveChangesClicked("primary")}
                ></SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handlePrimaryResetClicked}
                ></SendButton>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id === this.props.user.id;
    }
    return false;
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedNetsuite.empty_message.title}
        message={this.localizedNetsuite.empty_message.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage
        className={cx(styles.loadingMessage, {
          [styles.userOverriding]: this.userOverriding(),
        })}
        message={
          this.userOverriding()
            ? `${this.localizedNetsuite.loading.override}...`
            : `${this.localizedNetsuite.loading.config}...`
        }
        visible={true}
      />
    );
  }
}

export default NetsuiteConfigurationView;
